import { render } from "./ReportsToRead.vue?vue&type=template&id=c494254a&scoped=true&ts=true"
import script from "./ReportsToRead.vue?vue&type=script&lang=ts"
export * from "./ReportsToRead.vue?vue&type=script&lang=ts"

import "./ReportsToRead.vue?vue&type=style&index=0&id=c494254a&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c494254a"]])

export default __exports__